<div>A: <span #ask></span></div>
<div>B: <span #bid></span></div>
